var h = /* @__PURE__ */ ((r) => (r.DD = "DD", r.D = "D", r))(h || {}), M = /* @__PURE__ */ ((r) => (r.HH = "HH", r.H = "H", r.hh = "hh", r.h = "h", r))(M || {}), Y = /* @__PURE__ */ ((r) => (r.SSS = "SSS", r.S = "S", r))(Y || {}), t = /* @__PURE__ */ ((r) => (r.mm = "mm", r.m = "m", r))(t || {}), m = /* @__PURE__ */ ((r) => (r.MMMM = "MMMM", r.MMM = "MMM", r.MM = "MM", r.M = "M", r))(m || {}), c = /* @__PURE__ */ ((r) => (r.A = "A", r.a = "a", r))(c || {}), S = /* @__PURE__ */ ((r) => (r.ss = "ss", r.s = "s", r))(S || {}), d = /* @__PURE__ */ ((r) => (r.dddd = "dddd", r.dd = "dd", r.d = "d", r))(d || {}), f = /* @__PURE__ */ ((r) => (r.YYYY = "YYYY", r.YY = "YY", r))(f || {}), a = /* @__PURE__ */ ((r) => (r.YYYY = "%01%", r.YY = "%02%", r.MMMM = "%03%", r.MMM = "%04%", r.MM = "%05%", r.M = "%06%", r.DD = "%07%", r.D = "%08%", r.HH = "%09%", r.H = "%10%", r.hh = "%11%", r.h = "%12%", r.mm = "%13%", r.m = "%14%", r.ss = "%15%", r.s = "%16%", r.A = "%17%", r.a = "%18%", r.dddd = "%19%", r.dd = "%20%", r.d = "%21%", r.SSS = "%22%", r.S = "%23%", r))(a || {});
const u = {
  dayOfWeekNames: [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday"
  ],
  dayOfWeekNamesShort: [
    "Su",
    "Mo",
    "Tu",
    "We",
    "Th",
    "Fr",
    "Sa"
  ],
  monthNames: [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ],
  monthNamesShort: [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
  ]
}, p = (r, s, e = u) => {
  const l = "timezone" in e ? r.getUTCDate() : r.getDate();
  if (s === h.DD)
    return `${l}`.padStart(2, "0");
  if (s === h.D)
    return `${l}`;
  throw new Error(`[vue-filter-date-format]: Invalid date format '${s}'`);
}, v = (r, s, e = u) => {
  const l = "timezone" in e ? r.getUTCHours() : r.getHours(), D = l % 12 === 0 ? 12 : l % 12;
  if (s === M.HH)
    return `${l}`.padStart(2, "0");
  if (s === M.H)
    return `${l}`;
  if (s === M.hh)
    return `${D}`.padStart(2, "0");
  if (s === M.h)
    return `${D}`;
  throw new Error(`[vue-filter-date-format]: Invalid hours format '${s}'`);
}, H = (r, s, e = u) => {
  const l = "timezone" in e ? r.getUTCMilliseconds() : r.getMilliseconds();
  if (s === Y.SSS)
    return `${l}`.padEnd(3, "0");
  if (s === Y.S)
    return `${l}`;
  throw new Error(`[vue-filter-date-format]: Invalid milliseconds format '${s}'`);
}, y = (r, s, e = u) => {
  const l = "timezone" in e ? r.getUTCMinutes() : r.getMinutes();
  if (s === t.mm)
    return `${l}`.padStart(2, "0");
  if (s === t.m)
    return `${l}`;
  throw new Error(`[vue-filter-date-format]: Invalid minutes format '${s}'`);
}, $ = (r, s, e = u) => {
  const l = ("timezone" in e ? r.getUTCMonth() : r.getMonth()) + 1;
  if (s === m.MMMM)
    return e.monthNames[l - 1];
  if (s === m.MMM)
    return e.monthNamesShort[l - 1];
  if (s === m.MM)
    return `${l}`.padStart(2, "0");
  if (s === m.M)
    return `${l}`;
  throw new Error(`[vue-filter-date-format]: Invalid month format '${s}'`);
}, w = (r, s, e = u) => {
  const l = "timezone" in e ? r.getUTCHours() : r.getHours();
  if (s === c.A)
    return l < 12 ? "AM" : "PM";
  if (s === c.a)
    return l < 12 ? "am" : "pm";
  throw new Error(`[vue-filter-date-format]: Invalid period format '${s}'`);
}, T = (r, s, e = u) => {
  const l = "timezone" in e ? r.getUTCSeconds() : r.getSeconds();
  if (s === S.ss)
    return `${l}`.padStart(2, "0");
  if (s === S.s)
    return `${l}`;
  throw new Error(`[vue-filter-date-format]: Invalid seconds format '${s}'`);
}, n = (r, s, e = u) => {
  const l = "timezone" in e ? r.getUTCDay() : r.getDay();
  if (s === d.dddd)
    return e.dayOfWeekNames[l];
  if (s === d.dd)
    return e.dayOfWeekNamesShort[l];
  if (s === d.d)
    return `${l}`;
  throw new Error(`[vue-filter-date-format]: Invalid weekday format '${s}'`);
}, A = (r, s, e = u) => {
  const l = "timezone" in e ? r.getUTCFullYear() : r.getFullYear();
  if (s === f.YYYY)
    return `${l}`.padStart(4, "0");
  if (s === f.YY)
    return `${l % 100}`.padStart(2, "0");
  throw new Error(`[vue-filter-date-format]: Invalid year format '${s}'`);
}, C = (r) => r.replace(f.YYYY, a.YYYY).replace(f.YY, a.YY).replace(m.MMMM, a.MMMM).replace(m.MMM, a.MMM).replace(m.MM, a.MM).replace(m.M, a.M).replace(h.DD, a.DD).replace(h.D, a.D).replace(M.HH, a.HH).replace(M.H, a.H).replace(M.hh, a.hh).replace(M.h, a.h).replace(t.mm, a.mm).replace(t.m, a.m).replace(S.ss, a.ss).replace(S.s, a.s).replace(c.A, a.A).replace(c.a, a.a).replace(d.dddd, a.dddd).replace(d.dd, a.dd).replace(d.d, a.d).replace(Y.SSS, a.SSS).replace(Y.S, a.S), E = (r, s, e) => (r.includes(a.YYYY) && (r = r.replace(a.YYYY, e.yearTransformer(s, f.YYYY, e))), r.includes(a.YY) && (r = r.replace(a.YY, e.yearTransformer(s, f.YY, e))), r.includes(a.MMMM) && (r = r.replace(a.MMMM, e.monthTransformer(s, m.MMMM, e))), r.includes(a.MMM) && (r = r.replace(a.MMM, e.monthTransformer(s, m.MMM, e))), r.includes(a.MM) && (r = r.replace(a.MM, e.monthTransformer(s, m.MM, e))), r.includes(a.M) && (r = r.replace(a.M, e.monthTransformer(s, m.M, e))), r.includes(a.DD) && (r = r.replace(a.DD, e.dateTransformer(s, h.DD, e))), r.includes(a.D) && (r = r.replace(a.D, e.dateTransformer(s, h.D, e))), r.includes(a.HH) && (r = r.replace(a.HH, e.hoursTransformer(s, M.HH, e))), r.includes(a.H) && (r = r.replace(a.H, e.hoursTransformer(s, M.H, e))), r.includes(a.hh) && (r = r.replace(a.hh, e.hoursTransformer(s, M.hh, e))), r.includes(a.h) && (r = r.replace(a.h, e.hoursTransformer(s, M.h, e))), r.includes(a.mm) && (r = r.replace(a.mm, e.minutesTransformer(s, t.mm, e))), r.includes(a.m) && (r = r.replace(a.m, e.minutesTransformer(s, t.m, e))), r.includes(a.ss) && (r = r.replace(a.ss, e.secondsTransformer(s, S.ss, e))), r.includes(a.s) && (r = r.replace(a.s, e.secondsTransformer(s, S.s, e))), r.includes(a.A) && (r = r.replace(a.A, e.periodTransformer(s, c.A, e))), r.includes(a.a) && (r = r.replace(a.a, e.periodTransformer(s, c.a, e))), r.includes(a.dddd) && (r = r.replace(a.dddd, e.weekdayTransformer(s, d.dddd, e))), r.includes(a.dd) && (r = r.replace(a.dd, e.weekdayTransformer(s, d.dd, e))), r.includes(a.d) && (r = r.replace(a.d, e.weekdayTransformer(s, d.d, e))), r.includes(a.SSS) && (r = r.replace(a.SSS, e.millisecondsTransformer(s, Y.SSS, e))), r.includes(a.S) && (r = r.replace(a.S, e.millisecondsTransformer(s, Y.S, e))), r), N = (r, s = "YYYY-MM-DD HH:mm:ss", e = {}) => (e = {
  dateTransformer: p,
  hoursTransformer: v,
  millisecondsTransformer: H,
  minutesTransformer: y,
  monthTransformer: $,
  periodTransformer: w,
  secondsTransformer: T,
  weekdayTransformer: n,
  yearTransformer: A,
  ...u,
  ...e
}, "timezone" in e && r.setMinutes(r.getMinutes() + e.timezone), E(C(s), r, e)), I = {
  install(r, s) {
    r.filter("dateFormat", (e, l, D = {}) => N(e, l, { ...s, ...D }));
  }
};
export {
  N as dateFormat,
  I as default
};
